import { useNavigate, useLocation } from "react-router";
import { Icon } from "@iconify/react";
import { useContext, useRef } from "react";
import { UserContext } from "../context/user";
import { hasFeature } from "../lib/features";

export function BtMenu() {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const touchStartY = useRef(null);

  function getScrollContainer() {
    const containers = [...document.querySelectorAll("[data-bottom-nav-scroll]")];
    return containers
      .filter((container) => {
        const rect = container.getBoundingClientRect();
        const overflowY = window.getComputedStyle(container).overflowY;
        return (
          rect.width > 0 &&
          rect.height > 0 &&
          container.scrollHeight > container.clientHeight + 1 &&
          (overflowY === "auto" || overflowY === "scroll")
        );
      })
      .sort(
        (left, right) =>
          right.clientWidth * right.clientHeight -
          left.clientWidth * left.clientHeight,
      )[0];
  }

  function forwardWheel(event) {
    const container = getScrollContainer();
    if (!container) return;
    event.preventDefault();
    container.scrollTop += event.deltaY;
  }

  function handleTouchStart(event) {
    if (event.touches.length === 1) {
      touchStartY.current = event.touches[0].clientY;
    }
  }

  function forwardTouch(event) {
    if (touchStartY.current == null || !event.touches.length) return;
    const container = getScrollContainer();
    if (!container) return;

    const currentY = event.touches[0].clientY;
    const deltaY = touchStartY.current - currentY;
    touchStartY.current = currentY;
    event.preventDefault();
    container.scrollTop += deltaY;
  }

  function handleTouchEnd() {
    touchStartY.current = null;
  }

  let items = [
    { text: "Vender", route: "", icon: "mdi:view-dashboard-outline" },
  ];

  if (hasFeature(user, "hosteleria_comandas")) {
    items.push({ text: "Comandas", route: "comandas", icon: "mdi:bell-badge-outline" });
  }

  items.push({ text: "Tickets", route: "tickets", icon: "mdi:receipt-text-outline" });
  items.push({ text: "Ajustes", route: "settings", icon: "mdi:cog-outline" });

  return (
    <nav
      aria-label="Navegación principal"
      className="pointer-events-none absolute inset-x-0 bottom-[var(--bottom-nav-bottom)] z-40 flex animate-fade-up justify-center px-3 select-none animate-once"
    >
      <div
        data-bottom-nav-dock
        onWheel={forwardWheel}
        onTouchStart={handleTouchStart}
        onTouchMove={forwardTouch}
        onTouchEnd={handleTouchEnd}
        className="pointer-events-auto flex h-14 w-fit max-w-full touch-none items-center gap-1 rounded-[1.125rem] border border-blue-200/90 bg-white/95 p-1 shadow-[0_10px_30px_-14px_rgba(37,99,235,0.35)] ring-1 ring-blue-100/70 backdrop-blur-xl"
      >
        {items.map((item) => {
          const active = item.route === "" ? pathname === "/" : pathname === "/" + item.route;
          return (
            <button
              type="button"
              key={item.route}
              aria-current={active ? "page" : undefined}
              onClick={() => navigate("/" + item.route)}
              className={`relative flex h-12 w-12 shrink-0 touch-manipulation flex-col items-center justify-center gap-0.5 rounded-2xl px-1.5 outline-none transition-all duration-200 min-[380px]:w-[4.75rem] active:scale-[0.97] focus-visible:ring-2 focus-visible:ring-blue-500/30 ${
                active
                  ? "bg-blue-50 text-blue-600 ring-1 ring-blue-200/70"
                  : "text-neutral-500 hover:bg-neutral-100/80 hover:text-neutral-800"
              }`}
            >
              <Icon icon={item.icon} className="text-[22px]" />
              <span className="hidden text-[11px] font-medium leading-none min-[380px]:inline">
                {item.text}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
